export default __webpack_public_path__ + "static/media/first-aid.3e43c7ec.svg";